'use client';

import type { ReactNode } from 'react';

import { ProductMarkThreeOrnament } from './product-mark-three-ornament';
import { createYouPowerProjectThreeScene } from './you-power-project-three-scene';

type YouPowerProjectThreeOrnamentProps = {
  /** Static logo markup shown until (and unless) the WebGL scene is live. */
  children: ReactNode;
};

/**
 * Client island wrapping the You Power Project showcase mark with the extruded
 * Three.js scene. Delegates lifecycle to ProductMarkThreeOrnament.
 */
export function YouPowerProjectThreeOrnament({
  children,
}: YouPowerProjectThreeOrnamentProps) {
  return (
    <ProductMarkThreeOrnament createScene={createYouPowerProjectThreeScene}>
      {children}
    </ProductMarkThreeOrnament>
  );
}
